import * as React from 'react';
import { observer } from 'mobx-react';
import Image from '../../../../../../Image';
import { findLink } from '../../../../../../../LinkyLinky';
import { ProductLicenseResource } from '../../../../../Types';
import { translation } from '../../../../../../../Translations';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { TranslationsContext } from '@execonline-inc/translations';

interface Props {
  productLicense: ProductLicenseResource;
}

const IncludesFollowingContentIcon: React.FC<Props> = ({ productLicense }) =>
  findLink('asset', productLicense.links)
    .map((url) => (
      <TranslationsContext.Consumer>
        {(ts) => (
          <Image
            src={url.href}
            alt={translation('Includes following content icon')(ts)}
            style="mr-3 h-5 w-5 bg-gray-10 bg-cover bg-no-repeat"
          />
        )}
      </TranslationsContext.Consumer>
    ))
    .getOrElse(emptyFragment);

export default observer(IncludesFollowingContentIcon);
